/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Type_Weekly_PaymentInputs */

const en_jobs_type_weekly_payment = /** @type {(inputs: Jobs_Type_Weekly_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly payment reminder`)
};

const he_jobs_type_weekly_payment = /** @type {(inputs: Jobs_Type_Weekly_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תזכורת תשלום שבועית`)
};

/**
* | output |
* | --- |
* | "Weekly payment reminder" |
*
* @param {Jobs_Type_Weekly_PaymentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_type_weekly_payment = /** @type {((inputs?: Jobs_Type_Weekly_PaymentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Type_Weekly_PaymentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_type_weekly_payment(inputs)
	return he_jobs_type_weekly_payment(inputs)
});